const GLOSSARY_ITEMS = [
  {
    id: 1,
    term: 'Adaptation',
    abbreviation: null,
    description: 'enhancing resilience to a changing climate',
    url: '/learn/module/3/session/1/part/1',
  },
  {
    id: 2,
    term: 'Afforestation',
    abbreviation: null,
    description: "planting trees in areas that haven't recently had any tree cover, in order to create a forest",
    url: '/learn/module/3/session/1/part/3',
  },
  {
    id: 3,
    term: 'Agroforestry',
    abbreviation: null,
    description: 'land use management system that integrates trees with crops or pasture',
    url: '/learn/module/3/session/2/part/1',
  },
  {
    id: 4,
    term: 'Air pollution',
    abbreviation: null,
    description: 'presence of harmful substances in the air that negatively affect human health, ecosystems, and the climate',
    url: '/learn/module/1/session/1/part/5',
  },
  {
    id: 6,
    term: 'Carbon Market',
    abbreviation: null,
    description: 'a trading environment that allows emitted carbon to be bought and sold',
    url: '/learn/module/4/session/1/part/2',
  },
  {
    id: 7,
    term: 'Carbon sinks',
    abbreviation: null,
    description: 'anything that absorbs more carbon from the atmosphere than it releases',
    url: '/learn/module/3/session/1/part/3',
  },
  {
    id: 8,
    term: 'Clean and green cooking technologies',
    abbreviation: null,
    description: 'using modern, efficient, and environmentally friendly technologies and fuels for cooking',
    url: '/learn/module/3/session/1/part/2',
  },
  {
    id: 9,
    term: 'Climate',
    abbreviation: null,
    description: 'average of weather conditions over a longer period, in a particular location',
    url: '/learn/module/1/session/1/part/1',
  },
  {
    id: 10,
    term: 'Climate change',
    abbreviation: null,
    description: 'long-term changes in global or regional climate patterns',
    url: '/learn/module/1/session/1/part/1',
  },
  {
    id: 11,
    term: 'Climate finance',
    abbreviation: null,
    description: 'financing that supports mitigation and adaptation actions that will address climate change',
    url: '/learn/module/4/session/1/part/1',
  },
  {
    id: 12,
    term: 'Climate Justice',
    abbreviation: null,
    description: 'is the idea that climate change should be addressed in a fair way, recognizing that those who contributed least to the problem often suffer its worst effects and should be protected and supported.',
    url: '/learn/module/3/session/1/part/3',
  },
  {
    id: 13,
    term: 'Climate policies',
    abbreviation: null,
    description: 'a set of rules, laws, and actions to address climate change',
    url: '/learn/module/2/session/3/part/3',
  },
  {
    id: 14,
    term: 'Disaster-resistant infrastructure',
    abbreviation: null,
    description: 'infrastructure that can accommodate shocks and stresses posed by disasters',
    url: '/learn/module/3/session/1/part/2',
  },
  {
    id: 15,
    term: 'Climate variability',
    abbreviation: null,
    description: 'refers to natural, short-term changes in typical weather',
    url: '/learn/module/1/session/1/part/1',
  },
  {
    id: 16,
    term: 'Climate-Smart Agriculture',
    abbreviation: 'CSA',
    description: 'practices that sustainably increase productivity and system resilience while reducing greenhouse gas emissions',
    url: '/learn/module/3/session/1/part/3',
  },
  {
    id: 17,
    term: 'Community engagement',
    abbreviation: null,
    description: 'dynamic, collaborative process of working with and through communities',
    url: '/learn/module/3/session/3/part/1',
  },
  {
    id: 18,
    term: 'Community resilience',
    abbreviation: null,
    description: 'the ability of a community to recover from a disaster or persist sustainably in the face of a new, ongoing hardship',
    url: '/learn/module/4/session/2/part/1',
  },
  {
    id: 19,
    term: 'Conservation agriculture',
    abbreviation: null,
    description: 'farming system that promotes minimum soil disturbance',
    url: '/learn/module/3/session/2/part/1',
  },
  {
    id: 20,
    term: 'Crop failure',
    abbreviation: null,
    description: 'crops fail to produce the expected quantity or quality of produce',
    url: '/learn/module/2/session/3/part/2',
  },
  {
    id: 21,
    term: 'Cyclone',
    abbreviation: null,
    description: 'a storm or system of winds that rotates about a center of low atmospheric pressure',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 22,
    term: 'Deforestation',
    abbreviation: null,
    description: 'clearing or thinning of forests by humans',
    url: '/learn/module/1/session/1/part/3',
  },
  {
    id: 23,
    term: 'Drought',
    abbreviation: null,
    description: 'a deficiency of precipitation over an extended period of time (usually a season or more), resulting in a water shortage',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 24,
    term: 'Drought-resistant crops',
    abbreviation: null,
    description: 'the ability of plants to withstand periods of low water availability',
    url: '/learn/module/3/session/2/part/1',
  },
  {
    id: 25,
    term: 'Dry spell',
    abbreviation: null,
    description: 'a prolonged period of dry weather',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 26,
    term: 'Early Warning Systems',
    abbreviation: 'EWS',
    description: 'a system that forecasts extreme weather events and informs at-risk communities before the event occurs, enabling early action, to save lives and reduce the impact of of the extreme event',
    url: '/learn/module/3/session/1/part/2',
  },
  {
    id: 27,
    term: 'Earth orbital changes',
    abbreviation: null,
    description: "variation in the shape of Earth's orbit",
    url: '/learn/module/1/session/1/part/2',
  },
  {
    id: 29,
    term: 'Extreme rainfall',
    abbreviation: null,
    description: 'when a location receives much more rain or snow than normal',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 31,
    term: 'Flood',
    abbreviation: null,
    description: 'an overflow of water that submerges land that is usually dry',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 32,
    term: 'Food and Agriculture Organization',
    abbreviation: 'FAO',
    description: 'a specialized agency of the United Nations that leads international efforts to defeat hunger',
    url: '/learn/module/3/session/2/part/1',
  },
  {
    id: 33,
    term: 'Fuel shortage',
    abbreviation: null,
    description: 'the demand of fuel exceeds the available supply',
    url: '/learn/module/2/session/3/part/2',
  },
  {
    id: 34,
    term: 'Gender equality',
    abbreviation: null,
    description: 'means that all people, regardless of their gender, have the same rights, opportunities, and access to resources in every area of life—like education, work, and decision-making.',
    url: '/learn/module/3/session/3/part/1',
  },
  {
    id: 35,
    term: 'Gendered roles',
    abbreviation: null,
    description: 'social and cultural expectations about how people should behave, think, or act based on their gender',
    url: '/learn/module/2/session/3/part/3',
  },
  {
    id: 37,
    term: 'Green Climate Fund',
    abbreviation: 'GCF',
    description: 'the largest global fund dedicated to help fight climate change',
    url: '/learn/module/4/session/1/part/2',
  },
  {
    id: 38,
    term: 'Greenhouse effect',
    abbreviation: null,
    description: "the process through which heat is trapped near Earth's surface by greenhouse gases",
    url: '/learn/module/1/session/1/part/4',
  },
  {
    id: 39,
    term: 'Greenhouse Gases',
    abbreviation: 'GHG',
    description: 'gases in the atmosphere, that trap heat from the sun and warm the Earth’s surface, contributing to climate change.',
    url: '/learn/module/1/session/1/part/4',
  },
  {
    id: 41,
    term: 'Heat wave',
    abbreviation: null,
    description: 'a period where local excess heat accumulates over a sequence of unusually hot days and nights',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 46,
    term: 'Local knowledge',
    abbreviation: null,
    description: 'understandings and skills developed by individuals and communities, specific to the place where they live',
    url: '/learn/module/3/session/3/part/1',
  },
  {
    id: 48,
    term: 'Mitigation',
    abbreviation: null,
    description: 'reducing or removing green house gases',
    url: '/learn/module/3/session/1/part/1',
  },
  {
    id: 50,
    term: 'Natural disasters',
    abbreviation: null,
    description: 'harmful impact on a community brought by natural phenomenon or hazard',
    url: '/learn/module/2/session/3/part/2',
  },
  {
    id: 52,
    term: 'Natural Resource Management',
    abbreviation: 'NRM',
    description: 'the management of natural resources such as land, water, soil, plants and animals',
    url: '/learn/module/2/session/2/part/1',
  },
  {
    id: 53,
    term: 'Non-renewable resources',
    abbreviation: null,
    description: 'resource that cannot be replenished naturally',
    url: '/learn/module/2/session/2/part/1',
  },
  {
    id: 54,
    term: 'Ocean acidification',
    abbreviation: null,
    description: "ongoing decrease in the pH of the Earth's ocean",
    url: '/learn/module/1/session/1/part/5',
  },
  {
    id: 55,
    term: 'Policy Advocacy',
    abbreviation: null,
    description: 'the process of influencing decision-makers to affect the outcome of public policies',
    url: '/learn/module/4/session/2/part/1',
  },
  {
    id: 56,
    term: 'Reforestation',
    abbreviation: null,
    description: 'the practice of restoring previously existing forests and woodlands that have been destroyed or damaged',
    url: '/learn/module/3/session/1/part/3',
  },
  {
    id: 57,
    term: 'Renewable resources',
    abbreviation: null,
    description: 'resource that can be replenished naturally over time',
    url: '/learn/module/2/session/2/part/1',
  },
  {
    id: 59,
    term: 'Soil conservation',
    abbreviation: null,
    description: 'a combination of controlling erosion and maintaining soil fertility',
    url: '/learn/module/3/session/1/part/2',
  },
  {
    id: 60,
    term: 'Erosion',
    abbreviation: null,
    description: 'wearing away of the most fertile top layer of soil',
    url: '/learn/module/2/session/2/part/2',
  },
  {
    id: 61,
    term: 'Solar radiation',
    abbreviation: null,
    description: 'energy emitted by the sun, some of which reaches the Earth',
    url: '/learn/module/1/session/1/part/2',
  },
  {
    id: 62,
    term: 'Sustainable Development',
    abbreviation: null,
    description: 'meeting the needs of the present whilst ensuring future generations can meet their own needs',
    url: '/learn/module/4/session/1/part/1',
  },
  {
    id: 63,
    term: 'Sustainable forestry',
    abbreviation: null,
    description: 'managing forests in a way that will keep forests healthy',
    url: '/learn/module/2/session/2/part/2',
  },
  {
    id: 65,
    term: 'Volcanic eruptions',
    abbreviation: null,
    description: 'an eruption of volcanic material through a volcano',
    url: '/learn/module/1/session/1/part/2',
  },
  {
    id: 66,
    term: 'Vulnerability',
    abbreviation: null,
    description: 'the susceptibility of a system, individual, or community to harm or damage',
    url: '/learn/module/2/session/2/part/2',
  },
  {
    id: 67,
    term: 'Waste management',
    abbreviation: null,
    description: 'various actions taken to manage waste to minimise environmental impact and comply with regulations',
    url: '/learn/module/3/session/1/part/3',
  },
  {
    id: 68,
    term: 'Water conservation',
    abbreviation: null,
    description: 'the responsible use and management of water resources',
    url: '/learn/module/3/session/1/part/2',
  },
  {
    id: 70,
    term: 'Water scarcity',
    abbreviation: null,
    description: 'insufficient water resources to meet the basic needs of a given region',
    url: '/learn/module/2/session/3/part/2',
  },
  {
    id: 71,
    term: 'Watershed Management',
    abbreviation: null,
    description: 'any human action aimed at ensuring the sustainable use of natural resources in a watershed',
    url: '/learn/module/3/session/1/part/2',
  },
  {
    id: 72,
    term: 'Weather',
    abbreviation: null,
    description: 'state of the atmosphere at a particular time and place e.g. temperature',
    url: '/learn/module/1/session/1/part/1',
  },
  {
    id: 73,
    term: 'Wildfire',
    abbreviation: null,
    description: 'an unplanned and uncontrolled fire in an area of combustible vegetation',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 74,
    term: 'Youth Engagement',
    abbreviation: null,
    description: 'when young people participate in meaningful opportunities and roles that allow them to build on their strengths',
    url: '/learn/module/2/session/3/part/3',
  },
  {
    id: 75,
    term: 'El Niño',
    abbreviation: null,
    description: 'natural climate event when ocean water in the Pacific becomes warmer than usual, causing changes in weather around the world',
    url: '/learn/module/1/session/1/part/1',
  },
  {
    id: 76,
    term: 'Extreme wind',
    abbreviation: null,
    description: 'when a location is subjected to very strong winds that could cause damages such as fallen trees or damage to houses',
    url: '/learn/module/1/session/2/part/2',
  },
  {
    id: 77,
    term: 'Gender-Based violence',
    abbreviation: 'GBV',
    description: 'any harmful act directed at a person because of their gender, including physical, sexual, psychological, or economic abuse, often targeting women and girls',
    url: '/learn/module/2/session/3/part/2',
  },
];

export { GLOSSARY_ITEMS };
